import React, { ChangeEvent, Component } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { IGroup } from "@formant/core/model/IGroup";
import { InputElement } from "@formant/ui/component/common/Field";

import { groupStore } from "../../../stores";
import { Form } from "../../common/Form";
import { Heading3 } from "../../common/Heading3";
import { Popup } from "../../common/Popup";
import { SelectField } from "../../common/SelectField";
import { StandardButton } from "../../common/StandardButton";
import * as styles from "./GroupChooser.scss";

export interface IGroupChooserProps {
    visible: boolean;
    onClose: () => void;
    onChoice: (group: IGroup) => void;
}

@observer
export class GroupChooser extends Component<IGroupChooserProps> {
    @observable
    private loading: boolean = false;

    @observable
    private group?: IGroup;

    public render() {
        const { visible, onClose } = this.props;
        const { group } = this;

        return (
            <Popup
                visible={visible}
                onClose={onClose}
                className={styles["group-chooser"]}
            >
                <Heading3 className={styles.heading}>Share A Group</Heading3>
                <Form
                    className={styles.content}
                    onSubmit={this.onSubmit}
                    onLoading={this.onLoading}
                >
                    <p>Choose the group you'd like to share.</p>
                    <p className={styles.options}>
                        <SelectField
                            label=""
                            small={true}
                            className={styles["inline-field"]}
                            onChange={this.onChangeGroup}
                        >
                            <option value="" />
                            {groupStore.list()?.map(x => (
                                <option key={x.id} value={x.id}>
                                    {x.name}
                                </option>
                            ))}
                        </SelectField>
                    </p>
                    <div className={styles.bottom}>
                        <StandardButton
                            disabled={group === undefined}
                            primary={true}
                            className={styles.submit}
                            loading={this.loading || !groupStore.list()}
                        >
                            Choose Group
                        </StandardButton>
                    </div>
                </Form>
            </Popup>
        );
    }

    private onChangeGroup = async (event: ChangeEvent<InputElement>) => {
        const { value } = event.currentTarget;
        if (value === "") {
            this.group = undefined;
        } else {
            const group = await groupStore.fetchGet(value);
            if (group !== false) {
                this.group = group;
            }
        }
    };

    private onSubmit = () => {
        const { onChoice } = this.props;
        if (this.group) {
            onChoice(this.group);
        }
    };

    private onLoading = (loading: boolean) => {
        this.loading = loading;
    };
}
